import type { IFieldProps } from '../../elements/Field';
import type { FormContextProps } from '../../elements/formContext';
import { Field } from '../../elements/Field';
import { FormContextConsumer } from '../../elements/formContext';
import styles from './ReadonlyText.module.css';

interface IReadonlyTextInputProps {
    placeholder?: string;
    value: string | null;
}

export function ReadonlyTextInput(props: FormContextProps<IReadonlyTextInputProps>) {
    return (
        <FormContextConsumer {...props}>
            {(properties) => (
                <input
                    className={styles.formControl}
                    disabled
                    key="input"
                    placeholder={properties.placeholder}
                    type="text"
                    value={properties.value || ''}
                />
            )}
        </FormContextConsumer>
    );
}

export function ReadonlyTextField(props: FormContextProps<IReadonlyTextInputProps & IFieldProps>) {
    return (
        <Field {...props}>
            <ReadonlyTextInput {...props} />
        </Field>
    );
}
